import { log } from '../../utils/logger';
export class FormEvaluatorService {
    evaluateDisplayConditions(conditions, currentAnswers, context) {
        try {
            const allValues = Object.assign(Object.assign({}, context), currentAnswers);
            const evaluate = (variable, operator, value) => {
                const actual = allValues[variable];
                switch (operator) {
                    case '==':
                        return actual == value;
                    case '!=':
                        return actual != value;
                    case '>':
                        return actual > value;
                    case '>=':
                        return actual >= value;
                    case '<':
                        return actual < value;
                    case '<=':
                        return actual <= value;
                    case 'contains': {
                        const actualStr = Array.isArray(actual) ? actual.map(String) : [String(actual)];
                        const valueStr = Array.isArray(value) ? value.map(String) : [String(value)];
                        return valueStr.some((v) => actualStr.includes(v));
                    }
                    default:
                        return false;
                }
            };
            const results = conditions === null || conditions === void 0 ? void 0 : conditions.conditions.map((c) => evaluate(c.variable, c.operator, c.value));
            if (conditions.logicalOperator === 'OR') {
                return results.some((r) => r);
            }
            return results.every((r) => r);
        }
        catch (err) {
            log.error('Error in evaluateDisplayConditions:', err);
            return false;
        }
    }
    evaluateDisableConditions(disableConditions, currentAnswers, context = {}) {
        try {
            const { conditions, logicalOperator } = disableConditions;
            const results = conditions.map((cond) => {
                var _a;
                const userValue = (_a = currentAnswers[cond.variable]) !== null && _a !== void 0 ? _a : context[cond.variable];
                switch (cond.operator) {
                    case '==':
                        return userValue == cond.value;
                    case '!=':
                        return userValue != cond.value;
                    case '>=':
                        return userValue >= cond.value;
                    case '<=':
                        return userValue <= cond.value;
                    case 'contains':
                        if (Array.isArray(cond.value)) {
                            const normalizedUserValue = String(userValue);
                            return cond.value.map(String).includes(normalizedUserValue);
                        }
                        return false;
                    default:
                        return false;
                }
            });
            return logicalOperator === 'AND' ? results.every(Boolean) : results.some(Boolean);
        }
        catch (error) {
            log.error('Error evaluando condiciones de visibilidad:', error);
            return false;
        }
    }
}
